import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import routesConfig from './list';
import AllComponents from '../components';
import { queryString } from '../utils/utils';
import { route } from './routes';

class CRouter extends Component {
  constructor(props){
    super(props)
    this.state = {
      
    }
  }
  render() {
    return (
      <Switch>
        {Object.keys(routesConfig).map(key =>
          routesConfig[key].map(r => {
              const route = r => {
                const Component = AllComponents[r.component];
                return (
                  <Route
                        key = {r.key}
                        exact
                        path = {r.key}
                //   render={ () => (<Component />)}
                        render={props => {
                          const reg = /\?\S*/g;
                          const queryParams = window.location.hash.match(reg);
                          const { params } = props.match;
                          Object.keys(params).forEach(key => {
                              params[key] =
                                  params[key] && params[key].replace(reg, '');
                          });
                          props.match.params = { ...params };
                          const merge = {
                              ...props,
                              query: queryParams,
                              key:r.key
                          };
                          return ( <Component {...merge} /> )
                      }}
                  />
                );
            };
            return r.component ? route(r) : r.subs.map(r => route(r));
          })
        )}

         <Route render={() => <Redirect to={route.default.login} />} />
      </Switch>
    );
  }
}

export default CRouter;
